module.exports = __webpack_public_path__ + "static/media/homepage_img.35663a3c.png";